import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './theme/motion.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// The hub kit's dev-only warnings (components/hub/devWarn.ts) default to SILENT
// so they can never fire at a real user. This is the app's opt-in: CRA inlines
// this literal at build time, so production ships `false`. It sits below the
// imports because ES imports hoist regardless, and `import/first` is an error
// under eslint-config-react-app — the kit only reads it during render, which is
// long after this line runs.
(globalThis as { __TPL_DEV__?: boolean }).__TPL_DEV__ = process.env.NODE_ENV !== 'production';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
